import { version } from './lib/version';

export const baseUrl = 'https://api.supportchef.com';
export const sdkVersion = version;
